import { useEffect, useState } from "react";
import jsPDF from "jspdf";
import api from "../../services/api";
import { obterNomeEmpresa } from "../../services/seguranca";
import { useAppSelector } from "../../store/hooks";
import { Pagamento } from "../../services/tipos";
import { toast } from "react-toastify";
import { abrirPdfNoVisualizador, carregarLogoDaEmpresa } from "../pdf/abrir-pdf";
import { desenharReciboPagamento, locacaoCompletaParaRecibo } from "./recibo-pagamento-pdf";

interface ReciboPagamentoProps {
  pagamento: Pagamento;
  trigger: number;
}

export const ReciboPagamento: React.FC<ReciboPagamentoProps> = ({
  pagamento,
  trigger,
}) => {
  const token = useAppSelector((state) => state.token);
  const [locacao, setLocacao] = useState<any | null>(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const buscarLocacao = async (idLocacao: string) => {
    setCarregando(true);
    setErro(null);
    try {
      const response = await api.get(`/locacao/${idLocacao}`);

      if (!response.data.locatario || !response.data.veiculo) {
        throw new Error("Dados da locação incompletos");
      }

      const locacaoData = response.data;

      if (!locacaoData.empresa?.documento && locacaoData.idEmpresa) {
        try {
          const empresaResponse = await api.get(`/Empresa/${locacaoData.idEmpresa}`);
          locacaoData.empresa = empresaResponse.data;
        } catch {
          console.warn("Não foi possível buscar dados da empresa separadamente");
        }
      }

      setLocacao(locacaoData);
    } catch (error) {
      console.error("Erro ao buscar locação:", error);
      setErro("Erro ao carregar dados da locação");
      toast.error("Não foi possível carregar os dados completos da locação");
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    if (pagamento?.idLocacao) {
      buscarLocacao(pagamento.idLocacao);
    }
  }, [pagamento]);

  const gerarReciboPDF = async () => {
    if (!locacaoCompletaParaRecibo(locacao)) {
      toast.error("Dados da locação incompletos para gerar o recibo");
      return;
    }

    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const logo = await carregarLogoDaEmpresa(token);
    desenharReciboPagamento(pdf, pagamento, locacao, obterNomeEmpresa(token), logo);
    abrirPdfNoVisualizador(pdf, `recibo_${pagamento.id}`);
  };

  useEffect(() => {
    if (trigger > 0) {
      if (locacaoCompletaParaRecibo(locacao)) {
        gerarReciboPDF();
      } else {
        toast.error("Aguarde os dados da locação carregarem completamente");
      }
    }
  }, [trigger, locacao]);

  if (carregando) {
    return <div>Carregando dados para o recibo...</div>;
  }

  if (erro) {
    return <div className="text-red-500">{erro}</div>;
  }

  return null;
};
